import { apiFetch } from "./apiClient";

export function reporteFlujoCaja(params = {}) {
    const query = new URLSearchParams(params);
    return apiFetch(`/api/reportes/flujo-caja?${query.toString()}`);
}

export function reporteIngresosPorFuente(params = {}) {
    const query = new URLSearchParams(params);
    return apiFetch(`/api/reportes/ingresos-por-fuente?${query.toString()}`);
}

export function reporteGastosPorCategoria(params = {}) {
    const query = new URLSearchParams(params);
    return apiFetch(`/api/reportes/gastos-por-categoria?${query.toString()}`);
}

export function reporteComparativoMensual(params = {}) {
    const query = new URLSearchParams(params);
    return apiFetch(`/api/reportes/comparativo-mensual?${query.toString()}`);
}

export function reporteComparativoAnual(params = {}) {
    const query = new URLSearchParams(params);
    return apiFetch(`/api/reportes/comparativo-anual?${query.toString()}`);
}

export function reportePresupuestoVsReal(params = {}) {
    const query = new URLSearchParams(params);
    return apiFetch(`/api/reportes/presupuesto-vs-real?${query.toString()}`);
}

export function reporteDeudasPendientes() {
    return apiFetch(`/api/reportes/deudas-pendientes`);
}

export function reporteMetasAhorro() {
    return apiFetch(`/api/reportes/metas-ahorro`);
}